<template>
    <div class="d-wrapper">
      <div class="model" v-if="upload_loader">
      <span class="loader"></span>
      <span>Loading...........</span>
    </div>
        <tool-bar/>
        <div class="d-container">
          <nav-drawer :navItems="navItems"/>
          <template>
            <keep-alive>
              <component :is="currentComponent" :sub_step="sub_step" :sub_step_name="sub_step_name" :entity_index="entity_index"></component>
            </keep-alive>
          </template>

        </div>
        <!-- <scroll-icon></scroll-icon> -->
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import toolBar from  "./shell/dashboardToolbar.vue";
import navDrawer from  "./shell/dashboardNavdrawer.vue";
import feed from "./pages/overview/feed.vue";
//import myprofile from "./pages/myprofile/index.vue";
import mysalary from "./pages/mysalary/index.vue";
// pages
import overview from  "./pages/overview/dashboard.vue";
import payroll from  "./pages/payroll/index.vue";
import myself from  "./pages/myself/index.vue";
import myteam from  "./pages/myteam/index.vue";
import myTeamMembers from "./pages/myteammember/myTeamIndex.vue"
import organisation from  "./pages/organisation/index.vue";
import settings from  "./pages/settings/index.vue";
import reportsDashboard from "./pages/Reports/index.vue";
import companyPolicies from "./pages/companyPolicies/index.vue";
import changePasswordUser from "./pages/accountSettings/index.vue";
// import fbpDeclare from "./pages/HumanResources/FBPlock.vue";
import myProfile from "./pages/myself/myProfile.vue";
import stdReport from "./pages/stdReports/stdReport.vue"
import fbpDeclarationEss from "./pages/HumanResources/fbpDeclaration.vue"
import fbpClaimsEss from "./pages/HumanResources/fbpClaims.vue"
import payslipItSheet from "./pages/payslipsItsheets/payslipItsheet.vue"
import essResetPassword from "./pages/essResetPassword/essResetPassword.vue"
import incomeTax from "./pages/mysalary/incomeTax/index.vue";
import hsbcAccounts from "./pages/directPay/hsbcAccount/accountDetailsHsbc.vue"
import directPay  from "./pages/directPay/directPayComponentMapping.vue"
import letterManagement from "./pages/letterManagement/letterManagement.vue"



const mapNameToComponents = {
  "overview": overview,
  "feed": feed,
  "myself": myself,
  "myProfile":myProfile,
  //"myprofile": myprofile,
  "mysalary": mysalary,
  "myteam": myteam,
  "myTeamMembers": myTeamMembers,
  "payroll": payroll,
  "organisation": organisation,
  "reports": reportsDashboard,
  "settings": settings,
  "companyPolicies": companyPolicies,
  "accountSettings": changePasswordUser,
  // "fbpDeclare": fbpDeclare,
  "fbpDeclarationEss":fbpDeclarationEss,
  "stdReport": stdReport,
  "fbpClaimsEss" : fbpClaimsEss,
  "payslipItSheet" : payslipItSheet,
  "essResetPassword" : essResetPassword,
  "incomeTax" :incomeTax,
  "hsbcAccounts" : hsbcAccounts, 
  "directPay":directPay,
  "letterManagement": letterManagement,

}
const getPathForStep = (entity_index,step_name) => {
  return `/dashboard/${entity_index}/${step_name}`
}

const nav_items_dashboard = (entity_index) =>([
      // {
      //   type: "navitem",
      //   label: "Home",
      //   path: getPathForStep('home'),
      //   icon : "overview"
      // },
      {
        type: "navitem",
        label: "Home",
        path: getPathForStep(entity_index,'overview'),
        icon : "overview",
        nav_icon:"icon-home"
      },
      {
        type: "navitem",
        label: "Payroll",
        path: getPathForStep(entity_index,'payroll'),
        icon : "payroll",
        nav_icon: "icon-payroll"
      },
      // {
      //   type: "navitem",
      //   label: "Myself",
      //   path: getPathForStep(entity_index,'myself'),
      //   icon : "myself",
      //   nav_icon: require('@/assets/dashboard/ic_myself.svg')
      // },
      // {
      //   type: "navitem",
      //   label: "My Team",
      //   path: getPathForStep(entity_index,'myteam'),
      //   icon : "myteam",
      //   nav_icon: require('@/assets/dashboard/ic_myteam.svg')
      // },
      {
        type: "navitem",
        label: "Company",
        path: getPathForStep(entity_index,'organisation'),
        icon : "organisation",
        nav_icon: "icon-company"
      },
      // {
      //   type: "navitem",
      //   label: "Payroll",
      //   path: getPathForStep(entity_index,'payroll'),
      //   icon : "payroll",
      //   nav_icon: "icon-payroll"
      // },
      {
        type: "navitem",
        label: "Reports",
        path: getPathForStep(entity_index,'reports'),
        icon : "Reports",
        nav_icon: "icon-reports"

      },
      //  {
      //   type: "navitem",
      //   label: "My Team",
      //   path: getPathForStep(entity_index,'myTeamMembers'),
      //   icon : "icon-myteam",
      //   nav_icon:"icon-myteam"
      //  }, 
      {
        type: "navitem",
        label: "My Profile",
        path: getPathForStep(entity_index,'myProfile'),
        icon : "Reports",
        nav_icon: "icon-profile"
      },
      {
        type: "navitem",
        label: "My Salary",
        path: getPathForStep(entity_index, 'mysalary'),
        icon: "Reports",
        nav_icon: "icon-pay"
      },
      // {
      //   type: "navitem",
      //   label: "Tax Proof",
      //   path: getPathForStep(entity_index, 'incomeTax'),
      //   icon: "Reports",
      //   nav_icon: "icon-pay"
      // },
      {
        type: "navitem",
        label: "All Payslips & IT sheet",
        path: getPathForStep(entity_index,'payslipItSheet'),
        icon : "Reports",
        nav_icon: "icon-payroll",
      },
      {
        type: "navitem",
        label: "Standard Reports",
        path: getPathForStep(entity_index,'stdReport'),
        icon : "Reports",
        nav_icon: "icon-std-report",
      },
      // {
      //   type: "navitem",
      //   label: "Direct Pay",
      //   path: getPathForStep(entity_index,'directPay'),
      //   icon :"Reports",
      //   nav_icon: "icon-hsbc-pay",
      // },
      {
        type: "navitem",
        label: "ESS Reset Password",
        path: getPathForStep(entity_index,'essResetPassword'),
        icon : "Reports",
        nav_icon: "icon-settings",
      },
      {
        type: "navitem",
        label: "Letters",
        path: getPathForStep(entity_index,'letterManagement'),
        icon : "Reports",
        nav_icon: "icon-settings",
      },
      // {
      //   type: "navitem",
      //   label: "My Team",
      //   path: getPathForStep(entity_index,'myTeamMembers'),
      //   icon : "Reports",
      //   nav_icon: "icon-team"
      // },
      // {
      //   type: "navitem",
      //   label: "Settings",
      //   path: getPathForStep(entity_index,'settings'),
      //   icon : "settings-1",
      //   nav_icon: "icon-settings"
      // }
]);
export default {
  components: {
    toolBar,
    navDrawer,
  },
  data(){
    return{
      navItems : [],
      upload_loader:false,
      clientCodeBoolen:"",
      clientCode:["M32BG","M48BG","AD1BG","A3YPU","TSEMB","TWCDL","M8DMB","PPR55","PPR57","PPR58","PBTPL","NB005","PC6DL","AXYPU","PPR014","DO2DL"]
    }
  },
  created(){
    this.navItems =  nav_items_dashboard(this.entity_index);
    localStorage.removeItem("payroll");
  },
  async mounted() {
    // await this.fullProfiledata()
    this.updateNavItems()
    localStorage.removeItem("payroll");
  },
  props: ['step_name','sub_step','sub_step_name','entity_index'],
  computed:{
    currentComponent: function() {
     //  alert( this.step_name +''+ this.sub_step +''+ this.sub_step_name)
          return mapNameToComponents[this.step_name];
    },
    ifTeamLeader() {
      return this.userRoleState == "TEAMLEADER" ? true : false;
    },
    empId() {
      return localStorage.getItem("empId");
    },
    ifAnchor() {
      return this.userRoleState == "ANCHOR" ? true : false;
    },
    ifHr() {
      return this.userRoleState == "HR" ? true : false;
    },
    ifEmployee() {
      return this.userRoleState == "EMPLOYEE" ? true : false;
    },
    ifAuditor() {
      return this.userRoleState == "AUDITOR" ? true : false;
    },
    ifSuperAdmin() {
      return this.userRoleState == "SUPERADMIN" ? true : false;
    },
    ifAdmin() {
      return this.userRoleState == "ADMIN" ? true : false;
    },
    ifClientAdmin(){
      return this.userRoleState == "CLIENTADMIN" ? true : false
    },
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },

    ...mapState({
      homeLeId: (state) => state.onboard.organization.home_le_id,
      userRoleState: (state) => state.auth.role
    })
  },
  methods:{
    ...mapActions({
      act_getProfileData:
        "dashboard/payroll/monthlypayroll/employeeProfile/fetchAll",}),
    async fullProfiledata() {
      try {
        this.upload_loader=true
      
      let obj = {
        employee_id: this.empId,
      };
      let response = await this.act_getProfileData(obj);
      let employeeDetailsPayload = response.data.payload
      let cientCodeName = employeeDetailsPayload[0].legalEntityDetails.clientCode
      this.clientCodeBoolen = this.clientCode.some((record) => {
        return record == cientCodeName
      })
      this.upload_loader=false
      } catch (err) {
        console.log(err)
       this.upload_loader = false
    }
         
     },
    async updateNavItems() {
      if(this.ifTeamLeader || this.ifAnchor || this.ifSuperAdmin || this.ifAdmin){
         this.navItems.shift();
        this.navItems.splice(3,3);
        this.navItems.pop();
        this.navItems.pop();  
      } else if (this.ifHr || this.ifEmployee) {
      await this.fullProfiledata();
       this.navItems.unshift();
       this.navItems.splice(1,1);
       this.navItems.splice(1,2);
       this.navItems.splice(3);
      // this.clientCodeBoolen?this.navItems.splice(4):this.navItems.splice(3);
      /** This function is use to stop back button  */
        history.pushState(null, null, location.href);
        window.onpopstate = function () {
            history.go(1);
        };
      /** End here */
      }  else if(this.ifAuditor) {
        this.navItems = [];
      } else if (this.ifClientAdmin){
        const leidArray = [ '8a12c8e3-5d89-450d-b429-a3848eda64fe' ]  // 'c020d23c-e664-4c95-9e2d-0e08efd63b40'
        // this.navItems.unshift();
        // this.navItems.splice(1,3);
        console.log(this.le_id, this.homeLeId);
        if(this.homeLeId == this.le_id){
          this.navItems.unshift();
          this.navItems.splice(1,1);
          this.navItems.splice(1,2);
          //this.navItems.splice(3)
          if(!leidArray.includes(this.le_id)){
            this.navItems.pop();
          }
        }else{
          this.navItems.splice(0,6)
          if(!leidArray.includes(this.le_id)){
            this.navItems.pop();
          }
        }
      }
      else {
        return this.navItems;
      }
      const TAB_ID = Math.random().toString(36).slice(2)
         let heartbeat = {
        id: TAB_ID,
        timestamp: Date.now()
      };
      
      setInterval(() => {
        heartbeat.timestamp = Date.now(); // update timestamp
        localStorage.setItem("heartBeat", JSON.stringify(heartbeat));
      }, 1000); 
    }
  }
}
</script>


<style scoped lang="scss">
@import '@/scss/dashboard/_variables.scss'; // Common
.model {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;

  span {
    color: #f3f3f3;
    font-size: xx-large;
  }
}
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3b2867;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
